import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"

/* eslint-disable */
const MusicOptions = ({ musicOptions, underline, title, borderTop }) => {
  const options = musicOptions.data
  const [idxShow, setIdxShow] = useState(0)

  const slideLeft = () => {
    if (idxShow > 0) {
      setIdxShow(idxShow - 1)
      const optionsEl = document.querySelector(".options")
      optionsEl.children[idxShow - 1].classList.add("slide-left-in")
      optionsEl.children[idxShow].classList.add("slide-right-out")
    }
  }

  const slideRight = () => {
    idxShow < options.length - 1 && setIdxShow(idxShow + 1)
  }

  return (
    <div className="max-w-screen-reds-2xl w-full mx-auto">
      {borderTop && (
        <div className="border-t mt-20 mx-10 2xl:mx-auto lg:max-w-screen-2xl"></div>
      )}
      <h3 className="font-cardo text-center mt-20 mb-10 px-7">{title}</h3>
      <div className="relative">
        <div className="lg:hidden absolute w-full">
          <div className="absolute left-5 z-10">
            <div
              className="inline-block cursor-pointer"
              onClick={() => slideLeft()}
            >
              <StaticImage
                src="../../static/images/icon/angle-arrow-left.svg"
                alt="arrow"
              />
            </div>
          </div>
          <div className="absolute right-5 z-10">
            <div
              className="inline-block cursor-pointer"
              onClick={() => slideRight()}
            >
              <StaticImage
                src="../../static/images/icon/angle-arrow-right.svg"
                alt="arrow"
              />
            </div>
          </div>
        </div>
        <div className="lg:grid lg:grid-cols-5 space-x-2 options px-10 2xl:px-0">
          {options.map((option, index) => {
            const { value } = option.attributes
            return (
              <h6
                key={value}
                className={`font-bold text-center font-syne my-3 lg:block relative ${
                  idxShow === index ? "active" : "hidden"
                } ${underline ? "underline" : ""}`}
              >
                {value}
              </h6>
            )
          })}
        </div>
      </div>
      <div className="m-auto px-7 mt-20">
        <div className="w-full border-b"></div>
      </div>
    </div>
  )
}

export default MusicOptions
